import React, { useState } from "react";
import ReactTypingEffect from "react-typing-effect";

import "../../index.css";

import SocialLinks from "./SocialLinks";

//Picture
import HomePic from "../images/Home-2.png";

export default function Landing() {
  const [myJob] = useState(["Software Engineer.", "UI/UX Designer.", "AI Model Trainer."]);

  return (
    <div
      id="top"
      className="flex flex-col lg:flex-row items-center gap-10 lg:gap-8 pt-28 lg:pt-0 lg:min-h-screen"
    >
      <div className="flex-1 w-full">
        <h1 className="font-bold text-4xl md:text-6xl tracking-wide">
          Hello<span className="text-teal-500">,</span> I am <br />
          Andy Fransisko<span className="text-teal-500">.</span>
        </h1>
        <h2 className="text-xl md:text-2xl mt-8 text-gray-300">
          <ReactTypingEffect
            text={myJob}
            speed={200}
            eraseSpeed={300}
            typingDelay={1500}
          />
        </h2>

        <div className="mt-10 flex flex-wrap gap-4">
          <a
            href="#lets-talk"
            className="bg-teal-500 hover:bg-teal-400 text-black font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Let's Talk
          </a>
          <a
            href="#experiences"
            className="border border-teal-500 text-teal-500 hover:bg-teal-500 hover:text-black font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            View Experience
          </a>
        </div>

        <SocialLinks className="mt-12" />
      </div>

      <div className="flex-1 w-full self-center relative">
        <div
          className="absolute inset-0 bg-teal-500/10 blur-3xl rounded-full"
          aria-hidden="true"
        ></div>
        <img src={HomePic} width="100%" alt="Andy Fransisko" className="relative" />
      </div>
    </div>
  );
}
